export interface LetPassAccountSearchCriteria {
    companyCode: string | null,
    transactionDateFrom: Date | null,
    transactionDateTo: Date | null,
    activeInd: string | null,

    [key: string]: string | boolean | number | null | Object | undefined
}

export const EMPTY_LET_PASS_ACCOUNT_SEARCH_CRITERIA: LetPassAccountSearchCriteria = {
    companyCode: null,
    transactionDateFrom: null,
    transactionDateTo: null,
    activeInd: null
}
